var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:[
    `${_vm.carbonPrefix}--breadcrumb ${_vm.carbonPrefix}--skeleton`,
    { [`${_vm.carbonPrefix}--breadcrumb--no-trailing-slash`]: _vm.noTrailingSlash },
  ],attrs:{"aria-label":_vm.ariaLabel}},[_c('cv-breadcrumb-item-skeleton'),_c('cv-breadcrumb-item-skeleton'),_c('cv-breadcrumb-item-skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }